import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { answerScriptStrings } from "@/lib/answerScript/i18n";

// "Answer script" on the interview's start screen (2026-11-04): shown only when the
// server says this account may open it (admins, and beta testers the admin switched
// on). Opens the script in a new tab, except inside a frame (Admin → Responsive
// Preview's isolated test-user frame, 2026-11-05): a new tab wouldn't have the frame's
// sign-in, so the script opens in the frame, with a way back to the interview.
export function isFramed() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function AnswerScriptButton({ sessionId, lang, className = "" }) {
  const navigate = useNavigate();
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let alive = true;
    if (!sessionId) return undefined;
    api.get(`/sessions/${encodeURIComponent(sessionId)}/answer-script/available`)
      .then(({ data }) => alive && setAvailable(Boolean(data?.available)))
      .catch(() => {});
    return () => { alive = false; };
  }, [sessionId]);
  if (!available) return null;
  const s = answerScriptStrings(lang);
  const href = `/answer-script/${encodeURIComponent(sessionId)}`;
  const framed = isFramed();
  return (
    <a href={href} {...(framed ? {} : { target: "_blank", rel: "noopener noreferrer" })}
      onClick={framed ? (e) => { e.preventDefault(); navigate(href); } : undefined}
      title={s.buttonHint} data-testid="answer-script-button"
      className={`inline-flex items-center rounded-full border border-[color:var(--brand)] px-4 py-2 text-sm text-[color:var(--brand)] hover:bg-[color:var(--brand)]/10 ${className}`}>
      {s.button}
    </a>
  );
}
